import { faPencil, faPeopleGroup, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { Col, Nav, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { ResourceType } from "src/app/enums/ResourceType";
import { GetPropertiesFromEnum, ResizeImage, safeJson } from "src/app/helpers/Index";
import { Resource } from "src/app/interfaces/Index";
import { FormatBooleanYesNo } from "src/app/helpers/FormatBooleanYesNo";
import { FileService, ResourceService, SponsorService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./AdminResources.css";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: Resource[];
	items: Resource[];
	selectedItem: Resource;
	selectedItems: Resource[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	showPlayers: boolean;
	submitted: boolean;
	typeFilter: string;
	viewMode: string;
};

export class AdminResources extends React.Component<Props, State> {
	dt: any;
	toast: any;
	itemName: string = "Resource";
	itemNamePlural: string = "Resources";

	constructor(props: Props) {
		super(props);
		this.state = { isLoading: false, filters1: { "global": { value: null, matchMode: FilterMatchMode.CONTAINS } }, globalFilter: "", masterItems: [], selectedItem: new Resource(), selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, showPlayers: false, submitted: false , typeFilter: "all", viewMode: "tiles"};
	}

	categoryChange(e: any) {
		let selectedItem = { ...this.state.selectedItem };
		// selectedItem.type = e.value;
		this.setState({ selectedItem });
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({ showDeleteSelectionModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm(rowData: any) {
		const res = await (await ResourceService.deleteSingleById(this.state.selectedItem.id));
		console.log(res)
		if (!res.ok) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
		}
		this.toast.show({ closable: false, detail: "Resource has been deleted", life: 5000, severity: "warn", summary: "Resource deleted!" });
		this.getItems();
		this.setState({ showDeleteModal: false });
	}

	deleteSelectedItemConfirm() { }

	itemInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({ selectedItem: new Resource(), showItemInfoModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
		);
	}

	applyFilters(globalFilter: string, typeFilter: string) {
		const newData = this.state.masterItems.filter((item) => {
			const matchesName = globalFilter === "" || item.name?.toLowerCase().includes(globalFilter.toLowerCase());
			const matchesType = typeFilter === "all" || Number(item.resourceType) === (typeFilter === "video" ? ResourceType.Video : ResourceType.Image);
			return matchesName && matchesType;
		});
		this.setState({items: newData, globalFilter, typeFilter});
	}

	globalFilterChange(e: any) {
		const value = e === "" ? "" : e.target.value;
		this.applyFilters(value, e === "" ? "all" : this.state.typeFilter);
	}

	async getItems() {
		this.setState({ isLoading: true });
		const res = await safeJson(ResourceService.getAll());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}
		this.setState({ isLoading: false, items: res, masterItems: res });
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Resource({ ...this.state.selectedItem });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({ selectedItem });
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new Resource({ ...this.state.selectedItem });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({ selectedItem });
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{ paddingTop: "1.5rem" }}>
							<h5 style={{ paddingBottom: "1rem", paddingLeft: "1.5rem" }}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							{this.state.viewMode === "tiles" && this.renderTiles()}
							{this.state.viewMode === "list" &&
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({ selectedItems: e.value })} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{ height: "calc(100vh - 17.5rem)" }} value={this.state.items}>
								<Column field="name" header="Resource Name" sortable ></Column>
								<Column body={this.userStatusCell} field="resourceType" header="Resource Type" sortable></Column>
								<Column field="generalMessage" header="General Message?" sortable body={(data) => FormatBooleanYesNo(data.generalMessage)}></Column>
								<Column style={{ width: 75, float: "right" }} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({ selectedItem: rowData, showItemInfoModal: true })} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faPencil} style={{ color: colours.white }} />
										</Button>
										<Button onClick={() => this.setState({ selectedItem: rowData, showDeleteModal: true })} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30 }}>
											<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
										</Button>
									</div>
								)}></Column>
							</DataTable>
							}
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
								<Row>
									<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="name">Name</label>
											<InputText id="name" value={this.state.selectedItem.name} onChange={(e) => this.inputChange(e, "name")} />
										</div>
									</Col>
									<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="resourceType"> Resource Type</label>

											<Dropdown id="resourceType" onChange={(e: any) => this.setState({ selectedItem: { ...this.state.selectedItem, resourceType: e.value } })} options={GetPropertiesFromEnum(ResourceType)} optionLabel="name" optionValue="id" style={{ width: "100%" }} value={this.state.selectedItem.resourceType} />
										</div>
									</Col>
								</Row>
								<Row>
									<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="generalMessage">General Message?</label><br/>
											<InputSwitch checked={this.state.selectedItem.generalMessage} id="generalMessage" onChange={(e) => this.inputChange(e, "generalMessage")} disabled={this.state.selectedItem.resourceType > 0 || this.state.selectedItem.resourceType === undefined}/>
										</div>
									</Col>
									<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="sortOrder"> Sort Order</label>

											<InputNumber id="sortOrder" value={this.state.selectedItem.sortOrder} onChange={(e) => this.inputNumberChange(e, "sortOrder")} />
										</div>
									</Col>
								</Row>
								<TabView>
									<TabPanel header="Upload">
									<Row>
									<Col xs={2}>
										{this.renderPreview()
										}
									</Col>
									<Col xs={10}>
										<FileUpload accept={Number(this.state.selectedItem.resourceType) === ResourceType.Video ? "video/*" : "image/*"} auto customUpload name="resourceUrl" style={{ marginBottom: 10 }} uploadHandler={(data) => this.uploadImage(data, "resourceUrl")} mode="basic"></FileUpload>
									</Col>
								</Row>
									</TabPanel>
									<TabPanel header="From Url">
										<Row>
										<Col>
										<div className="field" style={{ marginBottom: 10 }}>
											<label htmlFor="resourceUrl">Url</label>
											<InputText id="resourceUrl" value={this.state.selectedItem.resourceUrl} onChange={(e) => this.inputChange(e, "resourceUrl")} />
										</div>
									</Col>
										</Row>
									</TabPanel>
								</TabView>
								
							</Dialog>
						</div>
					</Col>
				</Row>
				<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({ showDeleteModal: false })} style={{ width: 550 }} visible={this.state.showDeleteModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem", marginRight: "0.5rem" }} />
						{this.state.selectedItem &&
							<span>Are you sure you want to delete <b>{this.state.selectedItem.name}</b>?</span>
						}
					</div>
				</Dialog>
				<Toast ref={(el) => this.toast = el}></Toast>
				{this.state.showPlayers && (
					<Navigate replace={true} to={`/${environment.build.adminRoute}/Resource-players/${this.state.selectedItem.id}`} />
				)}
			</>
		);
	}

	renderPreview()
	{
		if(this.state.selectedItem.resourceType == ResourceType.Image)
		{
			return(
				<>
			{this.state.selectedItem.resourceUrl &&
				<img alt={this.state.selectedItem.name} className="mt-0 mx-auto mb-3 block shadow-2" src={this.state.selectedItem.resourceUrl} width="150" />
			}
			</>
			);
		}
		else{
			return(
				<>
			{this.state.selectedItem.resourceUrl &&
				<img alt={this.state.selectedItem.name} className="mt-0 mx-auto mb-3 block shadow-2" src={"https://knetic.org.uk/wp-content/uploads/2020/07/Video-Placeholder.png"} width="150" />
			}</>
			);
		}

		
	}

	renderTiles() {
		return (
			<div className="resource-tiles">
				{(Array.isArray(this.state.items) ? this.state.items : []).map((resource, i) =>
					<div className="resource-tile" key={`resource-tile-${i}`} onClick={() => this.setState({ selectedItem: resource, showItemInfoModal: true })}>
						<div className="resource-tile-preview">
							{Number(resource.resourceType) === 10
								? <>
									<video muted preload="metadata" src={`${resource.resourceUrl}#t=3`}/>
									<span className="resource-tile-play"><i className="pi pi-play"/></span>
								</>
								: <img alt={resource.name} loading="lazy" src={resource.resourceUrl}/>
							}
							<span className={`resource-tile-type ${Number(resource.resourceType) === 10 ? "video" : "image"}`}>{Number(resource.resourceType) === 10 ? "VIDEO" : "IMAGE"}</span>
						</div>
						<div className="resource-tile-body">
							<div className="resource-tile-name">{resource.name}</div>
							<div className="resource-tile-actions">
								<Button onClick={(e) => { e.stopPropagation(); this.setState({ selectedItem: resource, showItemInfoModal: true }); }} style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", padding: 0, width: 30 }}>
									<FontAwesomeIcon icon={faPencil} style={{ color: colours.white }} />
								</Button>
								<Button onClick={(e) => { e.stopPropagation(); this.setState({ selectedItem: resource, showDeleteModal: true }); }} style={{ backgroundColor: colours.error, borderColor: colours.error, height: 30, justifyContent: "center", padding: 0, width: 30 }}>
									<FontAwesomeIcon icon={faTrash} style={{ color: colours.white }} />
								</Button>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{ backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10 }} onClick={() => this.setState({ selectedItem: new Resource(), showItemInfoModal: true })}></Button>
				<Button className={this.state.viewMode === "tiles" ? "" : "p-button-outlined"} icon="pi pi-th-large" label="Tiles" style={this.state.viewMode === "tiles" ? { backgroundColor: colours.primary, borderColor: colours.primary } : {}} onClick={() => this.setState({ viewMode: "tiles" })}></Button>
				<Button className={this.state.viewMode === "list" ? "" : "p-button-outlined"} icon="pi pi-list" label="List" style={this.state.viewMode === "list" ? { backgroundColor: colours.primary, borderColor: colours.primary, marginLeft: 6 } : { marginLeft: 6 }} onClick={() => this.setState({ viewMode: "list" })}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
				<span style={{ marginRight: 14 }}>
					<Button className={this.state.typeFilter === "all" ? "" : "p-button-outlined"} label="All" style={this.state.typeFilter === "all" ? { backgroundColor: colours.buttons.add, borderColor: colours.buttons.add } : {}} onClick={() => this.applyFilters(this.state.globalFilter, "all")}></Button>
					<Button className={this.state.typeFilter === "image" ? "" : "p-button-outlined"} icon="pi pi-image" label="Images" style={this.state.typeFilter === "image" ? { backgroundColor: colours.buttons.add, borderColor: colours.buttons.add, marginLeft: 6 } : { marginLeft: 6 }} onClick={() => this.applyFilters(this.state.globalFilter, "image")}></Button>
					<Button className={this.state.typeFilter === "video" ? "" : "p-button-outlined"} icon="pi pi-video" label="Videos" style={this.state.typeFilter === "video" ? { backgroundColor: colours.buttons.add, borderColor: colours.buttons.add, marginLeft: 6 } : { marginLeft: 6 }} onClick={() => this.applyFilters(this.state.globalFilter, "video")}></Button>
				</span>
				<div className="flex justify-content-between">
					<Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={() => { this.globalFilterChange("") }} />
					<span className="p-input-icon-left">
						<i className="pi pi-search" />
						<InputText value={this.state.globalFilter} onChange={(e) => { this.globalFilterChange(e) }} placeholder="Keyword Search" />
					</span>
				</div>
				<Button icon="pi pi-upload" label="Export" style={{ backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10 }} onClick={() => this.dt?.exportCSV()}></Button>
			</>
		);
	}

	renderType(e: any) {
		return
	}

	async saveItem() {
		this.setState({ isLoading: true });
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(ResourceService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false, showItemInfoModal: false });
			this.toast.show({ closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!" });
		} else { // Save existing
			const res = await safeJson(ResourceService.updateSingleById(this.state.selectedItem.id, this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
				this.setState({ isLoading: false });
			}
			this.setState({ isLoading: false, showItemInfoModal: false });
			this.toast.show({ closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!" });
		}
		this.getItems();
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		if(this.state.selectedItem.resourceType == ResourceType.Image)
		{
			uploadData.append("mimeTypeKey", "Images");
		} else {
			uploadData.append("mimeTypeKey", "Videos");
		}
		
		const res = await FileService.upload(uploadData);
		if (!res.ok) {
			const detail = res.status === 413
				? "That file is too large to upload."
				: `Upload failed (${res.status}). Check the file type is allowed.`;
			this.toast.show({ closable: false, detail, life: 6000, severity: "error", summary: "Upload failed" });
			return;
		}
		const response = await res.json();
		if (!Array.isArray(response) || !response[0]?.location) {
			this.toast.show({ closable: false, detail: "The server did not accept the file.", life: 6000, severity: "error", summary: "Upload failed" });
			return;
		}
		let selectedItem = { ...this.state.selectedItem };
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		this.toast.show({ closable: false, detail: "File uploaded.", life: 3000, severity: "success", summary: "Upload complete" });
		await this.setState({ selectedItem });
	}

	userStatusCell = (rowData: any, item: any) => {
		return ResourceType[rowData[item.field]] === undefined ? "" : ResourceType[rowData[item.field]].split(/(?=[A-Z])/).join(" ");
	}

}